import { render } from "./messages.html?vue&type=template&id=6228397a&ts=true&external"
import script from "./messages.ts?vue&type=script&lang=ts&external"
export * from "./messages.ts?vue&type=script&lang=ts&external"

import "./messages.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__